import React, { createRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import LaoTable from "components/LAO/LaoTable";
import { endpoints } from 'helpers';
import { Grid } from "@material-ui/core";
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { laoSearchType } from "configs/appConstants";
import useSetQuery, { useMultiSetQuery } from 'customHooks/useQuery';
import { getAllLAOViews, resetLAOViews } from 'reduxLib/services/LaoServices/laoViewsServices';
import { laoViewTableNames as laoViewTableNamesPlanning } from 'configs/appConstants';
import { laoExportLaodPlanColumns } from "reduxLib/constdata/LAO/laoExportLoadPlanColumns";
import { laoExportDRPColumns } from "reduxLib/constdata/LAO/laoExportDRPColumns";
import { resetFilters } from "reduxLib/services";

const useStylesPlanning = makeStyles(theme => ({
    tableContainerPlanning: {
      background: theme.palette.primary.base,
      borderRadius: theme.spacing(1.5),
      padding: `${theme.spacing(3)}px ${theme.spacing(8)}px ${theme.spacing(3)}px ${theme.spacing(8)}px`,
      marginTop: theme.spacing(7),
      [theme.breakpoints.down('sm')]: {
        padding: '0px',
        marginTop: theme.spacing(6),
      }
    },
    activePlanning: {
      opacity: "100%",
      cursor: 'pointer'      
    },
    fadedPlanning: {
      opacity: "30%",
      cursor: 'pointer'
    },
    volumePlanning: {
      display: 'flex',
      marginTop: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'space-evenly'
      }
    },
  }));

const LaoPlanningDetails = () => {
  const classes = useStylesPlanning();
  const { t } = useTranslation();
  const tableRefPlanning = createRef();
  const dispatch = useDispatch();
  const [controller] = useState(() => new AbortController());
  const [{tableType}] = useSetQuery();
  const setMultiQueryPlanning = useMultiSetQuery();
//   const [activeOrder, setActiveOrderPlanning] = useState("drp");
  const isMobileLao = useMediaQuery(useTheme().breakpoints.down('xs'));

  const clearFiltersFromStore = () => {
    dispatch(resetFilters({ type: 'lao', subtype: 'exportLoadPlanDetails' }));
    dispatch(resetFilters({ type: 'lao', subtype: 'exportDRPDetails' }));
  }

  const setTableTypePlanning = (values) => {
    let tableType = values === 'drp' ? "exportDRPDetails" : "exportLoadPlanDetails"
    // setActiveOrderPlanning(values);
    setMultiQueryPlanning({
      tableType: tableType,
      viewid: undefined,
      loadView: true
    });
    dispatch(resetLAOViews({
      tableName: laoViewTableNamesPlanning[tableType]
    }, controller));
    dispatch(getAllLAOViews({
      tableName: laoViewTableNamesPlanning[tableType]
    }, controller));
    clearFiltersFromStore();// Resets filters on tab change
  }

  // Resets filters on componnet unmount
  useEffect(() => clearFiltersFromStore, []);

  return (
    <Grid container className={classes.tableContainerPlanning} data-testid="lao-planning-tablecontainer">
        <Grid container className={classes.volumePlanning}>
            <Grid item md={4} lg={2}>
                <Typography data-testid="exportDRP" variant="h6" className={!tableType || tableType === "exportDRPDetails" ? classes.activePlanning : classes.fadedPlanning} onClick={() => setTableTypePlanning('drp')}>{isMobileLao ? t('exportDRPMobile') : t('exportDRPDetails')}</Typography>
            </Grid>
            <Grid item md={4} lg={2}>
                <Typography data-testid="exportLoadPlan" variant="h6" className={tableType && tableType === "exportLoadPlanDetails" ? classes.activePlanning : classes.fadedPlanning} onClick={() => setTableTypePlanning('loadPlan')}>{isMobileLao ? t('exportLoadPlanMobile'): t('exportLoadPlanDetails')}</Typography>
            </Grid>
        </Grid>
      <LaoTable
        fetchEndPoint={endpoints.lao.exportPlanning}
        columns={tableType === "exportLoadPlanDetails" ? laoExportLaodPlanColumns : laoExportDRPColumns}
        tableName={tableType === "exportLoadPlanDetails" ? "exportLoadPlanDetails" : "exportDRPDetails"}
        subType={tableType === "exportLoadPlanDetails" ? laoSearchType.exportLoadPlanDetails : laoSearchType.exportDRPDetails}
        filterType={tableType === "exportLoadPlanDetails" ? "laoExportLoadPlanFilters" : "laoExportDRPFilters" }
        tableRef={tableRefPlanning}
        filterExclusionArray={['searchStringList']}
        // searchText={tableType === "exportLoadPlanDetails" ? t('lao_order_details_search_helper_text_import') : t('lao_order_details_search_helper_text')}
        menuItem={'exports'}
        downloadAll={false}
      />
    </Grid>
  )
}

export default LaoPlanningDetails;